import Img from "@/components/Img";

const PLATE = "https://static.prod-images.emergentagent.com/jobs/ee367fd7-7831-450d-a3f3-6ebf4a256b24/images/5fb3849d124975cbfd356d43d1f5dddad51beebccfbef8ae41d228c0055e48ab.jpeg";

export function initialsOf(name) {
  return (name || "?")
    .split(" ")
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join("");
}

export default function Portrait({ name, photoUrl, className = "", monogramClass = "text-3xl" }) {
  return (
    <div
      className={`relative overflow-hidden bg-[#0A0E16] ${className}`}
      style={{ borderRadius: "var(--radius)" }}
      data-testid={`portrait-${photoUrl ? "photo" : "plate"}`}
    >
      <Img
        src={photoUrl || PLATE}
        width={640}
        sizes="(max-width: 768px) 50vw, 320px"
        alt={photoUrl ? name : ""}
        className="h-full w-full object-cover transition-transform duration-[1600ms] ease-out hover:scale-[1.06]"
      />
      {!photoUrl && (
        <>
          <div className="absolute inset-0 bg-gradient-to-t from-[#070B12] via-[#070B12]/25 to-transparent" />
          <span
            className={`absolute inset-0 flex items-center justify-center font-head tracking-[0.1em] text-[#D4AF37]/85 ${monogramClass}`}
          >
            {initialsOf(name)}
          </span>
        </>
      )}
    </div>
  );
}
